@if (isLoading() && rows().length === 0) {
	<div class="search-loading">
		<mat-spinner diameter="48"></mat-spinner>
		<p class="search-loading-text">Wyszukiwanie...</p>
	</div>
} @else if (!isLoading() && rows().length === 0 && query().trim().length >= 2) {
	<div class="search-empty">
		<h3 class="search-empty-title">Brak wyników</h3>
		<p class="search-empty-description">Nie znaleziono wpisów pasujących do „{{ query() }}"</p>
	</div>
} @else if (query().trim().length < 2) {
	<div class="search-hint">
		<p>Wpisz co najmniej 2 znaki, aby rozpocząć wyszukiwanie.</p>
	</div>
} @else {
	@if (errorMessage(); as msg) {
		<div class="search-error">{{ msg }}</div>
	}
	<div class="results-info">
		Znaleziono <strong>{{ totalItems() }}</strong> {{ totalItems() === 1 ? 'wpis' : 'wpisów' }} dla „{{ query() }}"
	</div>
	<div class="results-table-wrapper">
		@if (isLoading()) {
			<div class="results-loading-overlay">
				<mat-spinner diameter="32"></mat-spinner>
			</div>
		}
		<mat-table [dataSource]="matData" class="mat-elevation-z2 results-table">
			<ng-container matColumnDef="date">
				<mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.date }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="driver">
				<mat-header-cell *matHeaderCellDef>Kierowca</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<span class="driver-name">{{ element.driverFirstName }} {{ element.driverLastName }}</span>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="amount">
				<mat-header-cell *matHeaderCellDef>Kwota</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div class="amount-cell">
						<span
							class="amount-main"
							[class.amount-positive]="element.amount > 0"
							[class.amount-negative]="element.amount < 0"
						>
							<i
								class="fas {{ element.amount > 0 ? 'fa-arrow-up' : 'fa-arrow-down' }} amount-icon"
								aria-hidden="true"
							></i>
							{{ element.amount > 0 ? '+' : '' }}{{ element.amount | price | number: '1.2-2' }}
							{{ element.currency }}
						</span>
						@if (element.currency !== 'PLN' && element.targetCurrency !== 'EUR') {
							<span class="amount-sub">= {{ element.amountPln | price | number: '1.2-2' }} PLN</span>
						}
						@if (element.currency !== 'EUR' && element.targetCurrency === 'EUR') {
							<span class="amount-sub">= {{ element.amountEur | price | number: '1.2-2' }} EUR</span>
						}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="category">
				<mat-header-cell *matHeaderCellDef>Kategoria</mat-header-cell>
				<mat-cell *matCellDef="let element">
					@if (element.categoryName) {
						<mat-chip-set>
							<mat-chip [highlighted]="false" disableRipple>{{ element.categoryName }}</mat-chip>
						</mat-chip-set>
					} @else {
						<span class="muted">-</span>
					}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="vehicle">
				<mat-header-cell *matHeaderCellDef>Pojazd</mat-header-cell>
				<mat-cell *matCellDef="let element">
					@if (element.vehicleName) {
						<span [matTooltip]="element.vehicleRegistrationNumber ?? ''">
							{{ element.vehicleName }}
						</span>
					} @else {
						<span class="muted">-</span>
					}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="hasOriginalDocument">
				<mat-header-cell *matHeaderCellDef>Oryginał</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<button
						type="button"
						class="original-document-toggle"
						(click)="toggleOriginalDocument(element, $event)"
						[attr.aria-pressed]="element.hasOriginalDocument"
						[matTooltip]="
							element.hasOriginalDocument
								? 'Kliknij, aby oznaczyć jako brak oryginału'
								: 'Kliknij, aby oznaczyć jako posiadany oryginał'
						"
					>
						<i
							class="original-document-icon"
							[class.fas]="element.hasOriginalDocument"
							[class.fa-file-alt]="element.hasOriginalDocument"
							[class.far]="!element.hasOriginalDocument"
							[class.fa-file]="!element.hasOriginalDocument"
							[class.original-document-icon--present]="element.hasOriginalDocument"
							[class.original-document-icon--missing]="!element.hasOriginalDocument"
							aria-hidden="true"
						></i>
						<span class="visually-hidden">
							{{
								element.hasOriginalDocument
									? 'Posiadamy oryginał dokumentu'
									: 'Brak oryginału dokumentu'
							}}
						</span>
					</button>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="description">
				<mat-header-cell *matHeaderCellDef>Opis</mat-header-cell>
				<mat-cell *matCellDef="let element">
					@if (element.description) {
						<span class="description-cell" [matTooltip]="element.description">
							{{ element.description }}
						</span>
					} @else {
						<span class="muted">-</span>
					}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="status">
				<mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<mat-chip-set>
						<mat-chip
							[highlighted]="element.status === 'NOT_SETTLED'"
							[class.status-chip-settled]="element.status === 'SETTLED'"
							disableRipple
						>
							{{ statusLabel[element.status] }}
						</mat-chip>
					</mat-chip-set>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="actions">
				<mat-header-cell *matHeaderCellDef>Akcje</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div class="action-buttons">
						@if (element.isMine) {
							<button
								mat-flat-button
								color="primary"
								(click)="openEdit(element); $event.stopPropagation()"
								matTooltip="Edytuj"
							>
								<i class="fas fa-edit"></i>
							</button>
							<button
								mat-flat-button
								color="warn"
								(click)="deleteEntry(element, $event)"
								matTooltip="Usuń"
							>
								<i class="fas fa-trash"></i>
							</button>
						} @else {
							<span
								class="not-author-hint"
								matTooltip="Tylko autor wpisu może go edytować lub usunąć"
								aria-label="Tylko autor wpisu może go edytować lub usunąć"
							>
								<i class="fas fa-lock" aria-hidden="true"></i> Tylko autor
							</span>
						}
					</div>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row
				*matRowDef="let row; columns: displayedColumns"
				(click)="openEdit(row)"
				[class.clickable-row]="row.isMine"
			></mat-row>
		</mat-table>
	</div>

	<mat-paginator
		[length]="totalItems()"
		[pageSize]="pageSize()"
		[pageIndex]="currentPage() - 1"
		[pageSizeOptions]="[10, 20, 50, 100]"
		(page)="onPageChange($event)"
		showFirstLastButtons
		aria-label="Wybierz stronę"
	>
	</mat-paginator>
}
